export default "/_next/static/sounds/RINGTONE_RVSD_1-61c93d8a06201a92ebe5ba66f1cfa789.mp3";